import ReactPixel from 'react-facebook-pixel';

const useFBPixeleventTracker = (title, data): void => {
  ReactPixel.trackCustom(title, data);
};

export default useFBPixeleventTracker;
